import { Component, OnInit } from '@angular/core';
import { CryptoService } from 'src/app/services/crypto.service';

@Component({
  selector: 'app-law',
  templateUrl: './law.component.html',
  styleUrls: ['./law.component.scss']
})
export class LawComponent implements OnInit {
  result: any;
  constructor(
    private cs: CryptoService
  ) { }

  ngOnInit() {
    // this.result = prompt('確認データを入力');
  }

  check() {
    // console.log('this.result: ', this.result);
    // const r = this.cs.decrypt(this.result);
    // setTimeout(() => {
    //   console.log(r);
    // }, 500);
  }

}
